import React from "react";
import { Container, Table } from "react-bootstrap";

export default function GizlilikPolitikasi() {
    return (
        <Container style={{ marginTop: 40, marginBottom: 40 }}>
            <h3>Securitas SmartM Gizlilik Politikası</h3>

            <p>
                Securitas web sitesi ziyaret edenlerin gizliliğini korumayı ilke edinmiştir.
                Bu “Gizlilik Politikası”, web sitesi kullanımıyla ilgili olarak hangi kişisel
                bilgilerin alındığını, nasıl kullanıldığını ve nasıl korunduğunu açıklar.
            </p>

            <h5>1. Genel İlkeler</h5>
            <p>
                Web sitesi ziyaretlerinde sistem istatistiksel veriler otomatik olarak toplanır.
                IP adresi, tarayıcı türü ve işletim sistemi gibi bilgiler anonimleştirilerek
                kullanılabilir. Kesinlikle tanımlanabilir kişisel bilgiler ziyaretçinin
                izni olmadan üçüncü taraflarla paylaşılmaz veya satılmaz.
            </p>

            <h5>2. Kişisel Veriler ve İşlenmesi</h5>
            <p>
                Ziyaretçiler tarafından sağlanan kişisel bilgiler, yalnızca ilgili kişinin rızası
                veya kanuni bir gereklilik olduğunda işlenir. Securitas, gerekli teknik ve
                organizasyonel önlemleri alarak kişisel veri güvenliğini sağlar.
            </p>

            <h5>3. Veri Güvenliği</h5>
            <p>
                Securitas, kişisel verileri korumak için gerekli tüm makul önlemleri uygular ve
                yetkisiz erişime, kayba veya suistimale karşı bilgileri güvenli şekilde saklar.
                Bağlı şirketlerle paylaşılan veriler de gizlilik taahhüdüne tabidir.
            </p>

            <h5>4. Çocuklara Ait Bilgiler</h5>
            <p>
                Web sitesi yetişkin kullanıcılar için tasarlanmıştır. 18 yaşından küçük kişilerin
                bilgi vermesi halinde yasal temsilcileri aracılığıyla verilerin silinmesi
                talep edilebilir.
            </p>

            <h5>5. Çerez Politikası</h5>
            <p>
                Securitas web sitesi çerezler kullanmaktadır. Çerezler, istatistiksel analiz,
                performans ve site deneyimi için toplanır ve ayrıntıları ayrı bir çerez politikası
                sayfasında açıklanır. Ziyaretçilerin çerezleri tarayıcı ayarlarından kontrol
                etme imkânı vardır.
            </p>

            <h5>6. Üçüncü Taraf İçerik</h5>
            <p>
                Site ziyaretleri sırasında üçüncü taraf içerikler gösterilebilir. Bu içerikler
                kendi çerezlerini yerleştirebilir ve bununla ilgili izleme dış kontrolünde olabilir.
            </p>

            <h5>7. Değişiklikler ve Bildirimler</h5>
            <p>
                Securitas, gizlilik politikasını önceden bildirimde bulunmaksızın güncelleme
                hakkını saklı tutar. Güncel politika web sitesinde yayınlandığı anda yürürlüğe girer.
            </p>

            <h5>8. İletişim ve Talepler</h5>
            <p>
                Kişisel veri talepleri veya silme istekleri için Securitas ile irtibata geçilebilir.
                Ayrıca politika ile ilgili sorular dijital@securitas.com.tr adresinden iletilebilir.
            </p>

            <h5>9. Konum Takip</h5>
            <Table bordered responsive>
                <tbody>
                    <tr>
                        <td><strong>Veri İşleme Amacı</strong></td>
                        <td>
                            Şirketimizin SmartM - Kişisel Cihaz Uygulaması kapsamında gerçekleştirilen
                            check-in ve check-out işlemleri kapsamında yürütülen operasyonel takip ve
                            hatırlatma bildirimleri.
                        </td>
                    </tr>

                    <tr>
                        <td><strong>İşlenen Veri Türleri</strong></td>
                        <td>
                            • Lokasyon ve fiziksel aktivite bilgisi<br />
                            • İşlem güvenliği log kayıtları
                        </td>
                    </tr>

                    <tr>
                        <td><strong>Hukuki Sebep</strong></td>
                        <td>
                            İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri
                            sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması.
                        </td>
                    </tr>

                    <tr>
                        <td><strong>Veri Toplama Yöntemi</strong></td>
                        <td>
                            SmartM uygulaması üzerinden izinli check-in ve kullanım ile otomatik veya
                            kısmen otomatik veri işleme.
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Container>
    );
}